import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';

function CustomModal({ props,changeVideoObject,type, onData }) {
    const [closeModal, setCloseModal] = useState(props);
    const [file, setFile] = useState();
    const [title, setTitle] = useState(changeVideoObject.videoName || "");
    const [isActiveButton,setIsActiveButton] = useState(true);
    const [message,setMessage] = useState("");
    const sendDataToParent = () => {
        // rowNumber'ı changeVideoObject'ten al, title kullanıcıdan
        onData({file, title, rowNumber: changeVideoObject.rowNumber});
    };




    useEffect(()=>{
        if (type === "NewMaterial") {
            setMessage("Add New Material")   
           }
           else if (type === "NewVideo")
               {
                   setMessage("Add New Video")
               }
               else if(type === "ChangeVideo")
                   {
                       setMessage("Change Video")
                   }
    },[])

   

    return (
        <>
            {closeModal && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999
                    }}
                    onClick={() => setCloseModal(false)}
                >
                    <div
                        style={{
                            backgroundColor: 'white',
                            borderRadius: '12px',
                            padding: '24px',
                            maxWidth: '500px',
                            width: '90%',
                            maxHeight: '80vh',
                            overflow: 'auto',
                            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div style={{ marginBottom: '20px', borderBottom: '1px solid #e0e0e0', paddingBottom: '12px' }}>
                            <h4 style={{ margin: 0, fontWeight: 'bold' }}>{message}</h4>
                        </div>

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '24px' }}>
                            <div>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                    Select File
                                </label>
                                <input 
                                    type='file' 
                                    onChange={setFile}
                                    style={{
                                        width: '100%',
                                        padding: '8px',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px'
                                    }}
                                />
                            </div>

                            <div>
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
                                    Title
                                </label>
                                <input 
                                    type='text' 
                                    placeholder='What is title' 
                                    value={title} 
                                    onChange={(e) => setTitle(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '10px',
                                        border: '1px solid #ddd',
                                        borderRadius: '6px',
                                        fontSize: '14px'
                                    }}
                                />
                            </div>
                        </div>

                        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                            <Button 
                                variant="secondary" 
                                onClick={() => setCloseModal(false)}
                                style={{ minWidth: '100px' }}
                            >
                                Close
                            </Button>
                            <Button 
                                variant="primary" 
                                onClick={sendDataToParent}
                                style={{ minWidth: '100px' }}
                            >
                                Save changes
                            </Button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default CustomModal;
